import { render } from "./PinkCatIcon.svg?vue&type=template&id=e8a95262"
const script = {}
script.render = render

export default script